// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"b761f661","977":"74ab9f6a"}[chunkId] + ".chunk.js";
};